import logo from "./../assets/logo.svg"
import "./../App.css"
import Header from "../components/Header"

function NoPage() {
	return (
		<div className="content">
			<Header title="Not found" />

			<main className="content">
				<h1>404 - PAGE NOT FOUND</h1>
				<img src={logo} className="App-logo" alt="logo" />
			</main>
		</div>
	)
}

export default NoPage
